export default {
  meta: {
    title: $localize`:@@payment.gift_card.page_title:Пополнение GIFT картами`
  }
};